import { QueryClient, QueryFunction } from "@tanstack/react-query";

const API_BASE = "__PORT_5000__".startsWith("__") ? "" : "__PORT_5000__";

async function throwIfResNotOk(res: Response) {
  if (!res.ok) {
    // Eugene 2026-06-14: вытаскиваем чистое .message/.error из JSON-тела (вместо
    // сырого `{"message":...}` в тосте). Префикс `STATUS: ` сохраняем — на него
    // опираются проверки вида err.message.includes("401") и .replace(/^\d+: /).
    let text = res.statusText;
    try {
      const raw = await res.text();
      if (raw) {
        try {
          const j = JSON.parse(raw);
          text = j?.message || j?.error || raw;
        } catch {
          text = raw;
        }
      }
    } catch { /* ignore body read errors */ }
    throw new Error(`${res.status}: ${text}`);
  }
}

export async function apiRequest(
  method: string,
  url: string,
  data?: unknown | undefined,
): Promise<Response> {
  const res = await fetch(`${API_BASE}${url}`, {
    method,
    headers: data ? { "Content-Type": "application/json" } : {},
    body: data ? JSON.stringify(data) : undefined,
    credentials: "include", // #8b Phase B: HttpOnly-cookie как первичный auth (не только Bearer)
  });

  await throwIfResNotOk(res);
  return res;
}

type UnauthorizedBehavior = "returnNull" | "throw";
export const getQueryFn: <T>(options: {
  on401: UnauthorizedBehavior;
}) => QueryFunction<T> =
  ({ on401: unauthorizedBehavior }) =>
  async ({ queryKey }) => {
    const res = await fetch(`${API_BASE}${queryKey.join("/")}`, { credentials: "include" }); // #8b Phase B

    if (unauthorizedBehavior === "returnNull" && res.status === 401) {
      return null;
    }

    await throwIfResNotOk(res);
    return await res.json();
  };

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      queryFn: getQueryFn({ on401: "throw" }),
      refetchInterval: false,
      refetchOnWindowFocus: true,   // Перезагружаем при возврате во вкладку — обрабатывает переименования, изменения другими пользователями и т.п.
      staleTime: 30 * 1000,         // 30 сек — после этого данные «устарели» и перезагружаются
      retry: false,
    },
    mutations: {
      retry: false,
    },
  },
});
